module.exports = __webpack_public_path__ + "assets/img/18_179.37c6f1e5.jpg";